import { Link } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import Stars from './stars';
import TeamWinRatio from './team-win-ratio';
import type { MemberSummary } from '../types/api.types';
import { formatMemberName } from '../utils/members';

interface MemberShortSummaryProps {
  member: MemberSummary;
}

export default function MemberShortSummary({ member }: MemberShortSummaryProps) {
  const bodyStyle = {
    padding: 0,
  };

  const tableStyle = {
    margin: 0,
  };

  const imageTdStyle = {
    width: '25%',
  };

  let caps: number;
  let wins: number;
  if (member.teamCaps != null) {
    caps = member.teamCaps;
    wins = member.teamWins ?? 0;
  } else {
    caps = 0;
    wins = 0;
  }

  return (
    <Card>
      <Link to={`/members/${member.id}`}>
        <Card.Header>
          <span>{formatMemberName(member)}</span>
          <Stars stars={member.individualWins ?? 0} />
        </Card.Header>
      </Link>
      <Card.Body style={bodyStyle}>
        <table className="table" style={tableStyle}>
          <tbody>
            <tr>
              <td style={imageTdStyle}>
                <img src={`/assets/${member.id}.jpg`} alt="" />
              </td>
              <td>
                <h5>Attendance</h5>
                <p>
                  <span>{member.attended}</span>
                  <span> tours</span>
                </p>
                <h5>Tournament</h5>
                <p>
                  <span>{member.individualWins ?? 0}</span>
                  <span> wins</span>
                </p>
                <h5>Ryd-Her Cup</h5>
                <p>
                  <span>Caps: </span>
                  <span>{caps}</span>
                </p>
                <TeamWinRatio wins={wins} caps={caps} />
              </td>
            </tr>
          </tbody>
        </table>
      </Card.Body>
    </Card>
  );
}
